// extracted by mini-css-extract-plugin
export default {"newPassInputs":"OZqll","passwordFormControl":"uV3ry","passwordInput":"C1DtY","infoText":"M30w7","offerLink":"zuq0J"};